"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.max = void 0;
var max = function (array) {
    return array.length === 0
        ? undefined
        : array.reduce(function (mx, curr) { return (curr > mx ? curr : mx); }, array[0]);
};
exports.max = max;
